// USA
export const locale = {
  lang: "en",
  data: {
    APP_NAME: "Edvance",
    TRANSLATOR: {
      SELECT: "Select your language",
    },
    MENU: {
      MENU_SECTION_TITLE: "Menu",
      DASHBOARD: "Dashboard",
      IMPORT: "Import",
      JOB_FINISHED: "Finished Jobs",
      JOB_PENDING: "Pending Jobs",
      CLAIM_AND_DISCOUNT: "Claim Job & Discount",
      CUSTOMER: "Customers",
      JOB_LIST: "Job List",
      PART_JOB: "Part Job",
      REPORTS: "Reports",
      SETTINGS: "Settings",

      //Sub & Children
      JOB_CREDIT_REP: "Job เครติด (REP)",
      CUSTOMER_STATS: "Customer Stats",
      CUSTOMER_CREDITS: "ลูกค้าเครดิต",
      ABNORMAL_CUSTOMER_CREDITS: "Abnormal Customer Credit",
      INSURANCE_STAT: "Insurance Stat",
      INSURANCE_CUSTOMER: "Insurance Customer",
      ABNORMAL_INSURANCE_CUSTOMER: "Abnormal Insurance Customer",

      CLAIM_SUMMARY: "Claim Summary",
      AFI: "AFI",
      AFC: "AFC",
      ACP: "ACP",
      FREE: "FREE",
      CAMPAIGN_JOB: "Campaign Job",

      PART_JOB_LIST: "Part Job List",
      BACK_ORDER: "Back Order",

      UPLOAD_REPORT_FILE: "Upload Report File",

      CREDIT_DEBTOR_SETTING: "Credit Debtor Setting",
      INSURANCE_COMPANY: "Insurance Company",
      DEALER_BRANCH: "Dealer Branch",
      STAFF: "Staff",
      LINE_NOTIFICATION_SETTINGS: "Line Notification Settings",
      PENDING_JOB_SETTING: "Pending Job Setting",
      DEBTOR_JOB_SETTING: "Debtor Job Setting",
      SERIES: "Car Model",
      USER: "User",
      NOTIFICATION: "Notifications",
      TOPSERV: "Topserv",
      SERVER_MAINTENANCES: "Server Maintenances",
      HEALTH_CHECK: "Health Check",

      JOB: "Jobs",
      INSURANCE: "Insurance",
      CUSTOMER_GROUP: "Customer Groups",
      CAR: "Cars",
      CAMPAIGN: "Campaigns",
      DISCOUNT: "Discounts",
      ROLE: "Roles",
    },
    USER_MENU: {
      PROFILE: "Profile",
      PURCHASE_ORDER: "Purchase Order",
      SIGN_IN: "Sign in",
      SIGN_OUT: "Sign out",
      CLASS_ROOM: "Class Room",
    },

    APP: {
      APP_NAME: "Edvance",
      SOCIAL_MEDIA: "Social Media",
      ACCOUNT_PROFILE: "Account Profile",
      DRAFT: "Draft",
      WAITING_DOC: "Waiting Document",
      IN_PROGRESS: "In Progress",
      HISTORY: "History",
      ATTACHMENTS: "Attachments",
      DOC_NO: "Doc No",
      DATE: "Date",
      DOCUMENT_NO: "Document No",
      TIMELINE: "Timeline",
      ISSUE_NO: "Issue No",
      SUBJECT: "Subject",
      DEAR: "Dear",
      NAME_TITLE: "Name Title",
      NAME: "Name",
      FIRST_NAME: "First Name",
      LAST_NAME: "Last Name",
      NICKNAME: "Nick Name",
      ACADEMY: "Academy",
      TYPE: "Type",
      PHONE: "Phone",
      DOCUMENT_CREATER: "Document Creater",
      DOB: "Date of birthday",
      DATE_FORMAT: "DD/MM/YYYY",
      YEAR: "Year",
      MONTH: "Month",
      DAY: "Day",
      TOPIC: "Topic",
      FILE_NAME: "File Name",
      FILE_PLACEHOLDER: "Browse or drop file here",
      FILE_PLACEHOLDER_ADD_ON: "Support PDF file",
      FILE_PLACEHOLDER_2: "Drag and drop file here. Or",
      UPLOADED_FILE: "Uploaded File",
      REMARK: "Remark",
      BY: "by",
      TEL: "Tel.",
      PASS: "Pass",
      FAIL: "Fail",
      CURRENT_INFORMATION: "Current Information",
      FULL_NAME: "Full Name",
      SEARCH_PLACEHOLDER: "Search...",
      SEARCH_USER_PLACEHOLDER: "Search...",
      SEARCH_PLACEHOLDER_TRACKING: "Search...",
      EMAIL: "Email",
      GENERAL_INFORMATION: "General Information",
      CONTACT_INFORMATION: "Contact Information",
      PLACE: "Place",
      START_TIME: "Start Time",
      END_TIME: "End Time",
      EVENT_TITLE: "Event Title",
      TOPIC_NAME: "Topic Name",
      PLEASE_ATTACH_DOCUMENTATION: "Please attach documentation",
      ADD: "Add",
      TIME_FORMAT: "Time HH:MM",
      TIME: "HH:MM",
      LOCATION: "Location",
      NOTE: "Note",
      REJECT: "Reject",
      WAITING: "Waiting",
      APPROVE: "Approve",
      COMMENT: "Comment",
      DETAIL: "Detail",
      APPROVED: "Approved",
      //
      INLINE_SEARCH: "Search:",
      YES: "Yes",
      NO: "No",
      NO_EVENTS: "No events",
      NO_ITEMS: "No Items",
      NO_ITEMS_FOUND: "No Items Found",
      NO_FILE_UPLOAD: "No File Uploaded",
      NO_REVISED_FILE: "No Revised File",
      NO_COMMENTS: "No Comments",

      SLOT_TIMES: "Slot times",
      PLEASE_COMMENT: "Please comment",

      USER: "User List",

      LOADING: "Loading",
      PROCESSING: "Processing",
      DOC_NO2: "Doc No.",

      // REPORTS
      DATE_PERIOD: "Date",
      MONTH_PERIOD: "Month",
      YEAR_PERIOD: "Year",
      INLINE_DATE_PERIOD: "Date Period:",
      INLINE_DATE: "Date:",
      INLINE_MONTH: "Month:",
      INLINE_YEAR: "Year:",
      TO: "To",
      START_DATE: "Start Date",
      END_DATE: "End Date",

      ITEMS: "Items",

      TEACHER: "TEACHER",
      WELCOME: "Welcome",

      BAHT: "Baht",
      PAY: "Pay",
      CANCEL_ORDER: "Cancel order",
      COURSE_DISCOUNT: "Discount",
      TOTAL_PRICE: "Total",
      AMOUNT: "Amount",
      COURSE_REVIEWS: "Reviews",
      ENROLL: "Enroll",
      ADD_CART: "Add cart",
      COURSE_OPTIONS: "Options",
      DURATION: "Duration",
      VIDEO_DURATION_EXTRA: "Video Duration Extra",
      COURSE_VIDEO: "Video",
      EXAMPLE: "Example",
      POST_EXAMPLE: "Post Example",
      COURSE_DETAIL: "Course Detail",

      BROWSE_IMAGE: "Browse",

      OLD_PASSWORD: "Old Password",
      RESET_PASSWORD: "Reset Password",
      CHANGE_PASSWORD: "เปลี่ยนรหัสผ่าน",
      PASSWORD_CONFIRMATION: "Password Confirmation",
      NEW_PASSWORD: "New Password",
      NEW_PASSWORD_CONFIRMATION: "New Password Confirmation",
      NEW_PASSWORD_REQUIRED: "กรุณาตั้งรหัสผ่านใหม่เพื่อดำเนินการ",

      COURSES: "คอร์สเรียน",
      STUDENT: "นักเรียน",
      BUY_NOW: "Buy Now",
      STUDENT_REVIEWS: "รีวิวจากน้องๆ",

      DETAILS: "Details",
      CATEGORIES: "Categories",
      SEARCH: "Search",
      BLOG: "Blog",
      SEARCH_BLOG: "Search Blog",
      TOTAL_BLOG: "Total Blog",
      PUBLIC: "Public",
      RECENT_BLOG: "Recent Blogs",
    },

    LANDING_PAGE: {
      ONLINE_COURSE: "เรียนง่าย เข้าใจง่าย",
      BANNER_VISION: {
        LINE_1: "เรียนง่าย เข้าใจง่าย",
        LINE_2: "แก้จุดอ่อน เพิ่มจุดแข็ง",
        LINE_3: "โจทย์ไหนก็ง่ายนิดเดียว",
        LINE_4:
          "เรียนจากที่ใหนก็ได้ เรียนในเวลาและสถานที่ ที่เหมาะกับตารางเวลาของคุณ",
        LINE_5: "ปรับเปลี่ยนได้ตามใจต้องการ",
      },
      COURSE_CATEGORY: "หมวดหมู่คอร์สเรียน",
      COURSE_CATEGORY_DESC:
        "ถ้ายังไม่สามารถตัดสินใจได้ว่าจะเลือกคอร์สเรียนออนไลน์ไหน เรามีตัวเลือกหมวดหมู่คอร์สเรียนที่เหมาะกับคุณ",
      MORE_COURSE: "ดูคอร์สทั้งหมด",
      WHY_WISE: "ทำไมต้องเรียนกับเรา",

      OUR_COURSE: "คอร์สเรียนของเรา",
    },
    ABOUT_US: {
      ABOUT: {
        PARAGRAPH_1:
          "We recognize the problems that many students encounter when learning English\nwhich is memorization without understanding, often using traditional learning methods\nBut here it's different! Because our teachers are not just instructors\nwith over 10 years of experience, but they understand the problems students are facing\nWe have summarized and created techniques to make English easy\nnot just memorization",
        PARAGRAPH_2:
          "We want students to give themselves a chance\nto try learning English the right way",
        LINE_1:
          "We recognize the problems that many students encounter when learning English",
        LINE_2:
          "which is memorization without understanding, often using traditional learning methods",
        LINE_3:
          "But here it's different! Because our teachers are not just instructors",
        LINE_4:
          "with over 10 years of experience, but they understand the problems students are facing",
        LINE_5:
          "We have summarized and created techniques to make English easy",
        LINE_6: "not just memorization",
        LINE_7: "We want students to give themselves a chance",
        LINE_8: "to try learning English the right way",
      },
    },
    BLOG: {
      FILTER: {
        CATEGORY: "Category",
        SEARCH: "Search",
        SEARCH_PLACEHOLDER: "Search...",
      },
    },
    PURCHASE_ORDER: {
      TITLE: "My Purchase Order",
    },
    AUTH: {
      WELCOME_TEXT: "Welcome to",
      WELCOME_DESC: "Please sign-in to your account for start using the system",
      USERNAME: "Username",
      EMAIL: "Email",
      PASSWORD: "Password",
      FORGOT_PASSWORD: "Forgot Password ?",
      NOT_REGISTER: "Not a Member yet?",
      ALREADY_REGISTER: "Already have an Account?",
      SIGN_IN: "Sign In",
      SIGN_UP: "Sign up",
      SUBMIT_SIGN_UP: "Submit",
      SIGN_OUT: "Sign Out",
      SIGN_INING: "Please wait",
      INVALID_LOGIN:
        "The username or password you entered is not valid. Please double-check and try again.",
      INVALID_VERIFY:
        "The username or password you entered is not valid or don't have permission. Please double-check and try again.",
      GENERAL: {
        OR: "Or",
        SUBMIT_BUTTON: "Submit",
        NO_ACCOUNT: "Don't have an account?",
        SIGNUP_BUTTON: "Sign Up",
        FORGOT_BUTTON: "Forgot Password",
        BACK_BUTTON: "Back",
        PRIVACY: "Privacy",
        LEGAL: "Legal",
        CONTACT: "Contact",
      },
      LOGIN: {
        TITLE: "Login Account",
        BUTTON: "Sign In",
      },
      FORGOT: {
        TITLE: "Forgotten Password?",
        DESC: "Enter your email to reset your password",
        SUCCESS: "Your account has been successfully reset.",
      },
      REGISTER: {
        TITLE: "Sign Up",
        DESC: "Enter your details to create your account",
        SUCCESS: "Your account has been successfuly registered.",
        NOT_REGISTER: "You aren't create an account?",
      },
      INPUT: {
        EMAIL: "Email",
        FULLNAME: "Fullname",
        PASSWORD: "Password",
        CONFIRM_PASSWORD: "Confirm Password",
        USERNAME: "Username",
      },
      VALIDATION: {
        INVALID: "{{name}} is not valid",
        REQUIRED: "{{name}} is required",
        MIN_LENGTH: "{{name}} minimum length is {{min}}",
        AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
        NOT_FOUND: "The requested {{name}} is not found",
        INVALID_LOGIN:
          "The username or password you entered is not valid. Please double-check and try again.",
        REQUIRED_FIELD: "Required field",
        MIN_LENGTH_FIELD: "Minimum field length:",
        MAX_LENGTH_FIELD: "Maximum field length:",
        INVALID_FIELD: "Field is not valid",
      },
    },
    COMPONENT: {
      ADD: "Add",
      CREATE: "Create",
      EDIT: "Edit",
      DELETE: "Delete",
      VIEW_DATA: "View Data",
      DOWNLOAD: "Download",
      UPLOAD: "Upload",
      BROWSE_FILE: "Browse File",
      PRINT: "Print",
      SAVE: "Save",
      SAVE_DRAFT: "Save As Draft",
      VIEW_DETAIL: "View Detail",
      SAVE_CHANGES: "Save Changes",
      NEW_EVENT: "New Event",
      CONFIRM: "Confirm",
      ACCEPT: "Accept",
      REJECT: "Reject",
      DISAPPROVE: "Disapprove",
      APPROVE: "Approve",
      APPROVED: "Approved",
      CONFIRM_REJECT: "Confirm Reject",
      CONFIRM_DISAPPROVE: "Confirm Disapprove",
      SUBMIT: "Submit",
      VIEW_COMMENT: "View Comment",
      APPROPRIATE: "Appropriate",
      MUST_REVISE: "Must Revise",
      SEND_EMAIL: "Send Email",
      ISSUE_A_CERTIFICATE: "Issue a Certificate",
      CANCEL: "Cancel",
      CLOSE: "Close",
      NEXT: "Next",
      IMPORT_DATA: "Import Data",
      IMPORT_PERSONNEL_DATA: "Import Personnel Data",
      FILE_FORMAT: "File Format",
      NEW: "New",
      IMPORT: "Import",
      REMOVE: "Remove",
    },
    VALIDATOR: {
      REQUIRED: "Field cannot be blank",
      REQUIRED_DATE: "Must be at least 1 Day",
      MUST_BE_AT_LEAST_X_CHARACTERS: "Must be at least {{value}} characters",
      MUST_CONTAIN_AT_LEAST_X_LETTER_IN_LOWER_CASE:
        "Must contain at least {{value}} letter in lower case",
      MUST_CONTAIN_AT_LEAST_X_LETTER_IN_UPPER_CASE:
        "Must contain at least {{value}} letter in upper case",
      MUST_CONTAIN_AT_LEAST_X_NUMBER: "Must contain at least {{value}} number",
      INVALID_EMAIL: "Please enter a valid email address",
      PASSWORD_MISMATCH: "Those passwords didn't match",
      PASSWORD_INVALID: "Invalid 'Password' pattern.",
      PLEASE_SELECT: "Please select",
      PLEASE_SELECT_TIME_SLOTS: "Please select time slots",
      PLEASE_SELECT_FILE: "Please select file",
      PLEASE_ADD_ALL_DOCUMENTS: "Please Add All Documents",

      DUPLICATE_DOC_NO:
        "The document number already exists in the system, please enter it again.",
    },
    SWEETALERT: {
      CONFIRMATION_TITLE: "Confirmation",
      CONFIRMATION_TEXT: "Are you sure you want to proceed this?",
      CONFIRMATION_DELETE_TEXT: "Are you sure you want to delete this?",
      CONFIRMATION_SAVE_TITLE: "Confirmation",
      CREATE_DATA: "Create Data",
      CREATE_DATA_TEXT: "Are you sure to create this data?",
      UPDATE_DATA: "Update Data",
      UPDATE_DATA_TEXT: "Are you sure to update this data?",
      SUCCESS_TITLE: "Success",
      SUCCESS_TEXT: "New information has been created.",
      SUCCESS_TEXT_UPDATE: "We have successfully updated the information.",
      SUCCESS_TEXT_DELETE: "We have successfully deleted this information.",
      ERROR_TITLE: "Oops",
      ERROR_TEXT: "Sorry, something went wrong.",
      WARNING_TITLE: "Warning",
      WARNING_TEXT:
        "Something is not right, It may prevent you from continuing.",
      WARNING_IMAGE_SIZE_TITLE: "Image is too large",
      WARNING_IMAGE_SIZE_TEXT:
        "Please make sure the image size is not larger than {{value}} {{unit}}",

      ERROR_APPROVER_DUPLICATE_OWNER: "Owner can not be approver",
      ERROR_COMMITTEE_DUPLICATE: "You have already elected this director.",
      ERROR_COMMITTEE_EXTERNAL: "External committee must contain at least 1",
      ERROR_COMMITTEE_INTERNAL: "Internal committee must contain at least 2",

      ERROR_NOTFOUND_DOC: "Document number not found",
      ERROR_NOTFOUND_DOC_BY_NAME: "Document not found by name",
      ERROR_REQUIRED: "Field cannot be blank",
    },
    MISC: {
      HELLO: "Hello",
      ASSOC_PROF: "Associate Professor",
    },
    TABLE: {
      NO_DATA_DISPLAY: "No data to display",
      NO_DATA: "No data",
      TOTAL: "Total",
      SUMMARY_TOTAL: "Summary Total",
      TOTAL_RESULT: "Total",
      TOTAL_LIST: "",
      CUSTOMER_PATIENT: "Customer / Patient",
      AGE: "Age",
      AGE_YEAR: "Age (Year)",
      ID: "ID",
      PHONE: "Phone",
      EMERGENCY: "Emergency",
      LINE: "LINE",
      LAST_UPDATED: "Last Updated",
      LAST_LOGIN: "Last Login",
      OPTION: "Option",
      BY: "by",
      CONNECTED: "Connected",
      NOT_CONNECTED: "Not Connected",
      DOC_NO: "Doc No.",
      DATE: "Date",
      SUB_TOTAL: "Total Price",
      NET_PRICE: "Total Price",
      PAID_PRICE: "Total",
      STATUS: "Status",
      PAID: "Paid",
      REFERENCE: "Reference",
      ISSUED_BY: "Issues by",
      ITEMS: "Items",
      PRICE_PER_UNIT: "Price/Unit",
      AMOUNT: "Amount",
      DISCOUNT: "Discount",
      BAHT: "Baht",
      MEDICINE_USAGE: "Medicine Usage",
      VAT: "Vat. ({{value}})",
      SERVICE_DATE: "Service Date",
      COMPLETED_DATE: "Completed Date",
      EXAMINATION_ROOM: "Examination Room",

      // REPORT
      RECEIPT_NO: "Receipt No",
      APPOINTMENT: "Appointment",

      // SETTING
      CODE: "Code",
      PRICE: "Price",
      UNIT: "Unit",
      NUMBER_OF_MEDICINE: "No. of Med.",
      ACCOUNT_NAME: "Account Name",
      ACCOUNT_NO: "Account No.",
      USED_FOR: "Used For",
      NAME: "Name",
      NAME_CODE: "Name / Code",
      LICENSE_NO: "License No.",
      EMAIL: "Email",
      ROLE: "Role",
      DESCRIPTION: "Description",
      GROUP: "Group",
      CATEGORY: "Category",
      TYPE: "Type",
      UNIT_NAME: "Unit Name",
      PRIMARY_UNIT: "Primary Unit",
      MULTIPILIER: "Amt./Unt.",
      TIMES: "Times",
      SELL_PRICE: "Sell Price",
      TYPE_OF_SERVICE: "Type of Service",
      SHOW: "Show",
      ENTRIES: "Entries",
      SEARCH: "Search",

      // REPORT
      OWNER_NAME: "Name",
      Q_TIMES: "Times",
      Q_PEOPLE: "People",

      PAGINATION_LIMIT_SHOWING:
        "Showing {{start_value}}  -  {{end_value}}  of  {{total_value}} entries",
    },
    GLOBAL: {
      ACCESSORIES: "Accessories",
      ACTUAL_PAY: "Actual Pay",
      ALL: "All",
      ALL_JOB_NO: "Job No.",
      AS_PERCENT: "% of",
      AVG_CAR: "Avg/Car",
      AVG_DC: "Avg Discount",
      BACK_ORDER: "Back Order",
      BILL: "Bill",
      BPE_NO: "BPE No.",
      BRAND: "Brand",
      BRANCH: "Branch",
      BRANCH_CODE: "Branch Code",
      CANCELED_JOB_INT: "Canceled Job (INT)",
      CANCELED_JOB_REPAY: "Canceled Job (Repay)",
      CANCELED_RECEIPT: "Canceled Receipt",
      CANCELED_RECEIPT_CASH: "Canceled Receipt (Cash)",
      CANCELED_RECEIPT_CREDIT: "Canceled Receipt (Credit)",
      CAR: "Car",
      CAR_AMOUNT: "Car Amt.",
      CAR_COUNT: "Car Count",
      CAR_OVER_3_YEAR: "Car Over 3 Year",
      CAR_YEAR: "Car Year",
      CARS: "Cars",
      CASH: "Cash",
      CASH_DETAIL: "Cash Detail",
      CLAIM_JOB: "Claim Job",
      CLAIM_NO: "Claim No.",
      CLAIM_TYPE: "Claim Type",
      CLEAR: "Clear",
      CREDIT: "Credit",
      CREDIT_RECEIVED: "Credit Received",
      CUSTOMER: "Customer",
      CUSTOMER_CODE: "Customer Code",
      CUSTOMER_TYPE: "Customer Type",
      DATE: "Date",
      DAY: "Day",
      DEALER_CODE: "Dealer Code",
      DEBTOR: "Debtor",
      EXCEL: "Excel",
      FILE: "File",
      FINISHED: "Finished",
      INSURANCE: "Insurance",
      INSURANCE_DETAIL: "Insurance Detail",
      INSURANCE_VALUE: "Insurance Value",
      INT_DOC_DATE: "INT Doc Date",
      INT_DOC_NO: "INT Doc No.",
      INTERNAL_JOB: "Internal Job",
      ITEMS: "Items",
      JOB_AMOUNT: "Job Amt.",
      JOB_CANCEL: "Cancel",
      JOB_CLOSE: "Job Close",
      JOB_CLOSE_BILL: "Close (Bill)",
      JOB_CLOSE_DATE: "Close Date",
      JOB_CLOSE_NO_BILL: "Close (No Bill)",
      JOB_COUNT: "Job Count",
      JOB_DATE: "Job Date",
      JOB_MOVEMENT: "Job Movement",
      JOB_NO: "Job No.",
      JOB_OPEN: "Job Open",
      JOB_STATUS: "Job Status",
      JOB_TYPE: "Job Type",
      JOB_VALUE: "Job Value",
      JOBS: "Jobs",
      JOBS_FINISHED: "Finished Jobs",
      JOBS_SUMMARY: "Jobs Summary",
      JOBS_WV: "Jobs W/V",
      KEYWORDS: "Keywords",
      LABOR_DC: "Labor DC",
      LABOUR_COST: "Labour Cost",
      LABOUR_SALE: "Labour Sale",
      MONEY: "Money",
      MONEY_WV: "Money W/V",
      MONTH_YEAR: "Month/Year",
      NEW_IMPORT: "New Import",
      NO_RESULT: "No Result",
      NON_VM: "Non VM",
      OIL_COST_TYPE_O: "Oil Cost (O)",
      OIL_SALE_TYPE_O: "Oil Sale (O)",
      OTHER_BRAND: "Other Brand",
      OUTSIDE_COST: "Outside Cost",
      OUTSIDE_SALE: "Outside Sale",
      PART_COST: "Part Cost",
      PART_RETURN: "Part Return",
      PART_SALE: "Part Sale",
      PARTS_DC: "Parts DC",
      PARTS_JOB: "Parts Job",
      PAY_TYPE: "Pay Type",
      PENDING_CAR: "Pending Car",
      PRICE: "Price",
      PRINT: "Print",
      RECEIVED_BALANCE_AND_CREDIT_RECEIVED:
        "Received Balance & Credit Received",
      REFRESH: "Refresh",
      REG_NO: "Reg No.",
      REP: "REP",
      REPAY: "Repay",
      REPAY_LIST: "Repay List",
      ROUND_AMOUNT: "Round Amt.",
      SEARCH_OPTIONS: "Search Options",
      SERIE: "Serie",
      SPECIAL_DISCOUNT: "Special Discount",
      STATS: "Stats",
      SUMMARY: "Summary",
      TAX_INV_DATE: "Tax Inv Date",
      TAX_INV_NO: "Tax Inv No.",
      TAX_INVOICE: "Tax Invoice",
      TOTAL: "Total",
      TOTAL_COST: "Total Cost",
      TOTAL_INCOME: "Total Income",
      TOTAL_RECEIVED: "Total Received",
      TOTAL_SUM: "Total",
      TOTAL_SUM_PC: "% Total",
      TOYOTA_BRAND: "Toyota Brand",
      VAT7: "VAT 7%",
      VIN_NO: "VIN No.",
      BACK: "Back",
      CUSTOMER_NAME: "Customer Name",
      CSV: "CSV",
      JOB_DETAIL: "Job Detail",
      MILEAGE: "Mileage",
      VEHICLE_SOLD_DATE: "Vehicle Sold Date",
      SA_NAME_OPEN_JOB: "SA Name (Open)",
      SA_CODE_OPEN_JOB: "SA Code (Open)",
      DATE_PERIOD: "Date Period",
      BILL_TYPE: "Bill Type",
      TAX_TYPE: "Tax Type",
      BILL_AMOUNT: "Bill Amount",
      VAT_AMOUNT: "VAT Amount",
      PARTS_JOB_DETAIL: "Parts Job Detail",
      RECEIPT_DATE: "Receipt Date",
      REFER: "Refer",
      PART_PO: "Part PO",
      PENDING_JOB_WAIT_PART: "Pending Job Wait Part",
      RESV_NO_SOP: "Resv No. (SOP)",
      RESERVED_DATE: "Reserved Date",
      ORDER_DATE: "Order Date",
      PO_NO: "PO No.",
      ORDER_TYPE: "Order Type",
      PART_NAME: "Part Name",
      ETA: "ETA",
      BO_QTY: "BO Qty",
      OUTLAY: "Outlay",
      PENDING_JOB_TRACKING: "Pending Job Tracking",
      FILE_STATUS_REPORT: "File Status Report",
      UNCOMPLETE: "Incomplete",
      COMPLETE: "Complete",
      DEBTOR_GROUP: "Debtor Group",
      ADD_GROUP: "Add Group",
      DEBTOR_NAME: "Debtor Name",
      CREDIT_DEBTOR_DETAIL: "Credit Debtor Detail",
      COMPANY_DEBTOR: "Company Debtor",
      CUSTOMER_ID: "Customer ID",
      NO_GROUP: "No Group",
      COMPANY_DETAIL: "Company Detail",
      COMPANY_NAME_TH: "Company Name (TH)",
      COMPANY_ADDRESS_TH: "Company Address (TH)",
      CONTACT_NAME_TH: "Contact Name (TH)",
      FINANCIAL_AMOUNT: "Financial Amount",
      PAYMENT_SCHEDULE: "Payment Schedule",
      BILLING_DATE: "Billing Date",
      FIRST_CONTACT_DATE: "First Contact Date",
      SELL_TARGET: "Sell Target",
      CHART_OF_AMOUNT_CODE: "Chart of Account Code",
      PRICE_A_Z: "Price (A-Z)",
      SA_CODE: "SA Code",
      DRAG_AND_DROP_FILE_HERE: "Drag and drop file here",
      BROWSE_FILES: "Browse Files",
      UPLOAD_QUEUE: "Upload Queue",
      UPLOAD_PROGRESS: "Upload Progress",
      REMOVE_ALL: "Remove All",
      STAFFS: "Staffs",
      STAFF_CODE: "Staff Code",
      DEALER: "Dealer",
      LINE_NOTIFY_SETTING: "Line Notify Setting",
      DATA_FILTER: "Data Filter",
      NOTIFY_TO: "Notify To",
      LINE_ROOM: "Line Room",
      DAY_TIME: "Day / Time",
      TOKEN: "Token",
      TOPIC: "Topic",
      PENDING_JOB_LOCATION_SETTING: "Pending Job Location Setting",
      CAR_LOCATION: "Car Location",
      OPTION_LIST: "Option List",
      ADD_NEW: "Add New",
      DEBTOR_JOB_STATUS_MASTER_SETTING: "Debtor Job Status Setting",
      STATUS: "Status",
      SERIES_CODE: "Series Code",
      TOYOTA: "Toyota",
      OPTION: "Option",
      OR: "or",
      FIRST_NAME: "First Name",
      LAST_NAME: "Last Name",
      SELECT: "-- Select --",
      REMOVE_TYPE: "Remove Type",
    },
    IMPORT: {
      DAILY_IMPORT: "Daily Import",
      AFI_FILES: "AFI Files",
      AFC_FILES: "AFC Files",
      ACP_FILES: "ACP Files",
      FILE_STATUS: "File Status",
      FILE_TYPE: "File Type",
      FILE_NAME: "File Name",
      FILE_SIZE: "File Size",
      STATUS: "Status",
      UPLOAD: "Upload",
      UPLOAD_DATE: "Upload Date",
      PROCESS_DATE: "Process Date",
      RECORDS_TOTAL: "Total Records",
      RECORDS_SUCCESS: "Success",
      RECORDS_FAILED: "Failed",
      UPLOADED_BY: "Uploaded By",
      DATE_FROM: "From",
      DATE_TO: "To",
      LAST_IMPORT_DATE: "Last Import",
      LAST_IMPORT_STATUS: "Last Status",
      TOTAL_FILES: "Total Files",
      PENDING_FILES: "Pending",
      JOB_COUNT: "Job Count",
      NEW_IMPORT: "New Import",
      IMPORT_DATE: "Import Date",
      UPLOADED: "Uploaded",
      NOT_UPLOADED: "Not Uploaded",
    },
    PENDING_JOB: {
      TITLE: "Pending Jobs",
      D1: "D1",
      D2_D7: "D2-D7",
      D8_D14: "D8-D14",
      D15_D30: "D15-D30",
      D30_PLUS: ">D30",
      DAY_RANGE: "Day Range",
      BACK_ORDER_NO: "Back Order No",
      PENDING_JOB_TRACKING: "Pending Job Tracking",
      SA_OPEN_JOB: "SA Open Job",
      SA_CLOSE_JOB: "SA Close Job",
      CUSTOMER_NAME: "Customer Name",
      NO_BP_TO_GS: "No BP to GS",
      ONLY_BP_TO_GS: "Only BP to GS",
      PENDING_JOB_SUMMARY: "Pending Job Summary",
      REMOVE_PENDING_JOB: "Remove Pending Job",
      PENDING_JOB_COUNT: "Pending Job Count",
      CAR_COUNT: "Car Count",
      LABOUR: "Labour",
      PART: "Part",
      EXTERNAL: "External",
      OIL: "Oil",
      SPECIAL_DISCOUNT: "Special Discount",
      TOTAL: "Total",
      AVG_PER_CAR: "Avg./Car",
      EXCEL_ALL: "Excel All",
      PRINT_ALL: "Print All",
      VM_ALL: "All",
      NON_VM: "Non VM",
      OPERATOR: "Operator",
    },
    JOB_CREDIT_REP: {
      TITLE: "Job Credit (REP)",
      CUSTOMER_LIST: "Customer List",
      REMOVED_CUSTOMER_LIST: "Removed Customer List",
      D1_D15: "D1-D15",
      D16_D30: "D16-D30",
      D31_D45: "D31-D45",
      D46_D90: "D46-D90",
      D90_PLUS: ">D90",
      INSURANCE_CODE: "Insurance Code",
      INSURANCE_NAME: "Insurance Name",
      CUSTOMER_JOB_TRACKING: "Customer Job Tracking",
      SA_OPEN_JOB: "SA Open Job",
      SA_CLOSE_JOB: "SA Close Job",
      EXCEL_ALL: "Excel All",
      PRINT_ALL: "Print All",
      OPERATOR: "Operator",
    },
    CUSTOMER_STATS: {
      TITLE: "Customer Stats",
      YEARLY: "Yearly",
      MONTHLY: "Monthly",
      SELECT_YEAR: "Select Year",
      SELECT_MONTH: "Select Month",
      CASH_CUSTOMER: "Cash Customer",
      CREDIT_CUSTOMER: "Credit Customer",
      INTERNAL_CUSTOMER: "Internal Customer",
      REPAY_CUSTOMER: "Repay Customer",
      DEBT_CODE: "Debt Code",
      TOTAL_SUM: "Total Sum",
      ALL_YEAR: "All Year",
      ALL_MONTH: "All Month",
      AVERAGE: "Average",
      INCOME_SRC: "Income Source",
      LABOUR_SALE: "Labour",
      SPARE_PART: "Spare Part",
      CHEMICAL: "Chemical",
      OUTSIDE_SALE: "Outside",
      PART_COST_PRICE: "Part Cost Price",
      AVG_DISCOUNT_PC: "Avg. Discount %",
      AVG_PERIOD_DEBT_PAY: "Avg. Debt Pay Period",
      DAY: "Day",
      CAR_AMOUNT: "Car Amount",
    },
    CREDIT_CUSTOMER: {
      TITLE: "Credit Customer",
      NOT_BILLING_AMOUNT: "Not Billing Amount",
      TOTAL_AMOUNT: "Total Amount",
      ACCOUNTING_BILLING_DOC: "Acc. Billing Doc",
    },
    ABNORMAL_CREDIT_CUSTOMER: {
      TITLE: "Abnormal Job Credit Customer",
      INSURANCE_CODE: "Insurance Code",
      INSURANCE_NAME: "Insurance Name",
      SA_OPEN_JOB: "SA Open Job",
      SA_CLOSE_JOB: "SA Close Job",
      CUSTOMER_DETAIL: "Customer Detail",
      CUSTOMER_HISTORY_DETAIL: "Customer History Detail",
      HISTORY: "History",
      DETAIL_TYPE: "Detail Type",
      OUTOP_CODE: "Outop Code",
      PART_NO: "Part No.",
      DETAIL: "Detail",
      PRINT_DESC: "Print Desc",
      SRV_FILE: "Srv File",
      USER: "User",
    },
    AFI_JOB: {
      AFI_LIST: "AFI List",
      MISTAKE: "Mistake",
      NO_SOLD_DATE: "No Sold Date",
      WARRANTY_NEARLY_EXPIRED: "Warranty Nearly Expired",
      WARRANTY_EXPIRED: "Warranty Expired",
      TMT_NOT_SENT: "TMT Not Sent",
      AFI_DETAIL: "AFI Detail",
      AFI_HISTORY_DETAIL: "AFI History Detail",
      HISTORY: "History",
      SA_OPEN_JOB: "SA Open Job",
      SA_CLOSE_JOB: "SA Close Job",
      OUTOP_CODE: "Outop Code",
      WARRANTY: "Warranty",
      DEALER_COST: "Dealer Cost",
      DETAIL_TYPE: "Detail Type",
      PART_NO: "Part No.",
      DETAIL: "Detail",
      PRINT_DESC: "Print Desc",
      PAY_BY: "Pay By",
      WARRANTY_TYPE: "Warranty Type",
      SRV_FILE: "Srv File",
      USER: "User",
    },
    AFC_JOB: {
      AFC_LIST: "AFC List",
      NO_SOLD_DATE: "No Sold Date",
      WARRANTY_EXPIRED: "Warranty Expired",
      TMT_NOT_SENT: "TMT Not Sent",
      AFC_DETAIL: "AFC Detail",
      AFC_HISTORY_DETAIL: "AFC History Detail",
      HISTORY: "History",
      SA_OPEN_JOB: "SA Open Job",
      SA_CLOSE_JOB: "SA Close Job",
      WARRANTY: "Warranty",
      LABOUR_COST: "Labour Cost",
      PART_COST: "Part Cost",
      OUTSIDE_COST: "Outside Cost",
      TOTAL: "Total",
      DETAIL_TYPE: "Detail Type",
      OUTOP_CODE: "Outop Code",
      PART_NO: "Part No.",
      DETAIL: "Detail",
      PRINT_DESC: "Print Desc",
      PAY_BY: "Pay By",
      WARRANTY_TYPE: "Warranty Type",
      SRV_FILE: "Srv File",
      USER: "User",
    },
    ACP_JOB: {
      ACP_LIST: "ACP List",
      NO_SOLD_DATE: "No Sold Date",
      WARRANTY_EXPIRED: "Warranty Expired",
      TMT_NOT_SENT: "TMT Not Sent",
      ACP_DETAIL: "ACP Detail",
      ACP_HISTORY_DETAIL: "ACP History Detail",
      HISTORY: "History",
      SA_OPEN_JOB: "SA Open Job",
      SA_CLOSE_JOB: "SA Close Job",
      WARRANTY: "Warranty",
      LABOUR_COST: "Labour Cost",
      PART_COST: "Part Cost",
      OUTSIDE_COST: "Outside Cost",
      TOTAL: "Total",
      DETAIL_TYPE: "Detail Type",
      OUTOP_CODE: "Outop Code",
      PART_NO: "Part No.",
      DETAIL: "Detail",
      PRINT_DESC: "Print Desc",
      PAY_BY: "Pay By",
      WARRANTY_TYPE: "Warranty Type",
      SRV_FILE: "Srv File",
      USER: "User",
    },
    FRE_JOB: {
      FRE_LIST: "FRE List",
      FRE_DETAIL: "FRE Detail",
      FRE_HISTORY_DETAIL: "FRE History Detail",
      HISTORY: "History",
      SA_OPEN_JOB: "SA Open Job",
      SA_CLOSE_JOB: "SA Close Job",
      DEALER_COST: "Dealer Cost",
      DETAIL_TYPE: "Detail Type",
      OUTOP_CODE: "Outop Code",
      PART_NO: "Part No.",
      DETAIL: "Detail",
      PRINT_DESC: "Print Desc",
      PAY_BY: "Pay By",
      WARRANTY_TYPE: "Warranty Type",
      SRV_FILE: "Srv File",
      USER: "User",
    },
    CAMPAIGN_JOB: {
      ALL_JOB: "All Job",
      MISTAKE_JOB: "Mistake Job",
      CAMPAIGN_DETAIL: "Campaign Detail",
      CAMPAIGN_HISTORY_DETAIL: "Campaign History Detail",
      HISTORY: "History",
      SA_OPEN_JOB: "SA Open Job",
      SA_CLOSE_JOB: "SA Close Job",
      CAMPAIGN_CODE: "Campaign Code",
      LABOUR_COST: "Labour Cost",
      PART_COST: "Part Cost",
      CHEMICAL: "Chemical",
      EXTERNAL_JOB: "External Job",
      DETAIL_TYPE: "Detail Type",
      OUTOP_CODE: "Outop Code",
      PART_NO: "Part No.",
      DETAIL: "Detail",
      PRINT_DESC: "Print Desc",
      PAY_BY: "Pay By",
      WARRANTY_TYPE: "Warranty Type",
      SRV_FILE: "Srv File",
      USER: "User",
    },
    JOB_LIST: {
      JOB_HISTORY_DETAIL: "Job History Detail",
      HISTORY: "History",
      SA_OPEN_JOB: "SA Open Job",
      SA_CLOSE_JOB: "SA Close Job",
      DETAIL_TYPE: "Detail Type",
      OUTOP_CODE: "Outop Code",
      PART_NO: "Part No.",
      DETAIL: "Detail",
      PRINT_DESC: "Print Desc",
      SRV_FILE: "Srv File",
      USER: "User",
    },
    PART_JOB_LIST: {
      TITLE: "Part Job List",
      BILL_F_REFER: "Bill F Refer",
      BILL_V_REFER: "Bill V Refer",
      BILL_B_REFER: "Bill B Refer",
      BILL_AB_REFER: "Bill A,B Refer",
    },
    CLAIM_SUMMARY: {
      TITLE: "Claim Summary",
      CLAIM_DETAIL: "Claim Detail",
      CLAIM_HISTORY_DETAIL: "Claim History Detail",
      SA_OPEN_JOB: "SA Open Job",
      SA_CLOSE_JOB: "SA Close Job",
      HISTORY: "History",
      DETAIL_TYPE: "Detail Type",
      OUTOP_CODE: "Outop Code",
      PART_NO: "Part No.",
      DETAIL: "Detail",
      PRINT_DESC: "Print Desc",
      SRV_FILE: "Srv File",
      USER: "User",
      SEND: "Send",
      NOT_SEND: "Not Send",
      PENDING: "Pending",
    },
    INSURANCE: {
      INSURANCE_DETAIL: "Insurance Company Detail",
      INSURANCE_CODE: "Insurance Code",
      CREATE_INSURANCE: "Create Insurance Company",
      EDIT_INSURANCE: "Edit Insurance Company",
      NO_INSURANCE_CODE: "No Insurance Code",
    },
    DEALER: {
      DEALER_AND_BRANCH: "Dealer & Branch",
      DEALER_INFO: "Dealer Information",
      BRANCH_LIST: "Branch List",
      COMPANY_CODE: "Company Code",
      TOPSERV_CODE: "Topserv Code",
    },
    USER: {
      USERNAME: "Username",
      EMAIL: "Email",
      ROLE: "Role",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm Password",
      CREATE_USER: "Create User",
      EDIT_USER: "Edit User",
      PASSWORD_HINT: "Leave blank to keep current password",
    },
    EMAIL: {
      EMAIL_SETTING: "Email Setting",
      NAME: "Name",
      EMAIL: "Email",
      SMTP_HOST: "SMTP Host",
      SMTP_PORT: "Port",
      SMTP_SETTINGS: "SMTP Settings",
      SMTP_USERNAME: "Username",
      SMTP_PASSWORD: "Password",
      SSL: "SSL",
      USE_SSL: "Use SSL/TLS",
      IS_ACTIVE: "Active",
      ACTIVE: "Active",
      INACTIVE: "Inactive",
      DESCRIPTION: "Description",
      CREATE_EMAIL_SETTING: "Create Email Setting",
      EDIT_EMAIL_SETTING: "Edit Email Setting",
      PASSWORD_HINT: "Leave blank to keep current password",
      TEST: "Test",
    },
    TOPSERV: {
      TOPSERV_SETTING: "Topserv Setting",
      USERNAME: "Topserv Username",
      CURRENT_PASSWORD: "Current Password",
      PASSWORD_EXPIRY_DATE: "Password Expiry Date",
    },
    SERVER_MAINTENANCE: {
      MAINTENANCE_SETTING: "Server Maintenance",
      DATA_RETENTION: "Data Retention",
      DR_FILE_AGE_TOPSERV: "Topserv File Age (days)",
      DR_DATA_AGE_TOPSERV: "Topserv Data Age (days)",
      BACKUP: "Backup",
      BU_DATE: "Backup Frequency (days)",
      BU_FILE_AGE: "Backup File Age (days)",
    },
    HEALTH_CHECK: {
      HEALTH_CHECK: "Health Check",
      OVERALL_STATUS: "Overall Status",
      SERVICES_ONLINE: "services online",
      LAST_CHECK: "Last check",
      REFRESH: "Refresh",
      SERVICE_LIST: "Service List",
      SERVICE_NAME: "Service Name",
      SERVICE_NAME_PLACEHOLDER: "e.g. API Server",
      SERVICE_CODE: "Service Code",
      SERVICE_CODE_PLACEHOLDER: "e.g. api_server",
      ENDPOINT: "Endpoint",
      CHECK_INTERVAL: "Check Interval",
      CHECK_INTERVAL_SECONDS: "Check Interval (seconds)",
      TIMEOUT: "Timeout",
      TIMEOUT_SECONDS: "Timeout (seconds)",
      CHECK_SETTINGS: "Check Settings",
      IS_ACTIVE: "Active",
      ACTIVE: "Active",
      INACTIVE: "Inactive",
      DESCRIPTION: "Description",
      CREATE_SERVICE: "Create Service",
      EDIT_SERVICE: "Edit Service",
      RESPONSE_TIME: "Response Time",
      STATUS_ONLINE: "Online",
      STATUS_OFFLINE: "Offline",
      STATUS_WARNING: "Warning",
      STATUS_UNKNOWN: "Unknown",
    },
  },
};
